function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import shallow from 'zustand/shallow';
import i18n from '@pureartisan/simple-i18n';
import clsx from 'clsx';
import { MdClose } from 'react-icons/md';
import useStore from '../store';
import { CoreButton } from './../../../core';
import { getMetric } from '../utils';
import { Button } from 'reactstrap';
import ChoroplethLegend from './ChoroplethLegend';
/**
 * Legend for map
 */

var MapLegend = function MapLegend(_ref) {
  var props = _extends({}, _ref);

  var _useStore = useStore(function (state) {
    return {
      setStoreValues: state.setStoreValues,
      activeMetric: state.activeMetric,
      breakpoint: state.breakpoint,
      showMobileLegend: state.showMobileLegend,
      indicators: state.indicators,
      activeView: state.activeView
    };
  }, shallow),
      setStoreValues = _useStore.setStoreValues,
      activeMetric = _useStore.activeMetric,
      breakpoint = _useStore.breakpoint,
      showMobileLegend = _useStore.showMobileLegend,
      indicators = _useStore.indicators,
      activeView = _useStore.activeView;

  var handleClose = function handleClose() {
    // console.log('handle close')
    setStoreValues({
      showMobileLegend: false
    }); // setShowMobileLegend(false)
  };

  var slideoutPanel = useStore(function (state) {
    return state.slideoutPanel;
  });

  var toggleFilterPanel = function toggleFilterPanel() {
    // console.log('toggleFilterPanel(), ', breakpoint)
    setStoreValues({
      slideoutPanel: {
        active: true,
        panel: 'filters' // filters or weights, presumably, possibly info

      }
    });
  };

  var metric = getMetric(activeMetric, indicators);

  var metricLabel = function metricLabel(metric) {
    if (!metric) return '';
    return !!i18n.translate(metric.id).length > 0 ? i18n.translate(metric.id) : metric.id;
  };

  if (!metric) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('map-legend', 'tour-desk-4', 'px-5', 'pt-4', 'pb-3', !!showMobileLegend ? 'show-mobile' : 'hide-mobile')
  }, (breakpoint === 'xs' || breakpoint === 'sm') && /*#__PURE__*/React.createElement(CoreButton, {
    id: "button_close_legend",
    label: i18n.translate("BUTTON_CLOSE_PANEL"),
    onClick: handleClose,
    color: "none",
    className: clsx('button-core', 'button-close-legend')
  }, /*#__PURE__*/React.createElement(MdClose, null), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, i18n.translate("BUTTON_CLOSE_PANEL"))), /*#__PURE__*/React.createElement("div", {
    className: "map-legend-metric-title"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "gotham16 w500"
  }, metricLabel(metric)), !(breakpoint === 'xs' || breakpoint === 'sm' || activeView === 'embed') && /*#__PURE__*/React.createElement(Button, {
    id: "map_legend_open_filter",
    color: "outlined",
    className: "map-legend-open-filter-panel knockout12 px-2 py-0",
    disabled: slideoutPanel.active && slideoutPanel.panel === 'filters',
    onClick: toggleFilterPanel
  }, i18n.translate('LINK_OPEN_FILTER_PANEL'))), /*#__PURE__*/React.createElement(ChoroplethLegend, {
    interactive: true,
    className: "tour-desk-7"
  }), /*#__PURE__*/React.createElement("span", {
    className: "hint"
  }, "Click on a color to toggle filters."));
};

MapLegend.defaultProps = {
  activeMetric: '',
  activeQuintiles: [1, 1, 1, 1, 1]
};
export default MapLegend;